import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { EventStore } from '../service/event.store';
import { OnyxEvent } from '../models/event';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class EventResolver implements Resolve<any> {
  constructor(private eventStore: EventStore,
              private translateService: TranslateService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<OnyxEvent> {
    const id = route.params[ 'id' ];
    if (!id) {
      throw new Error(this.translateService.instant('MESSAGES.ERROR.GET_EVENT'));
    }

    return this.eventStore.getEvent(route.params[ 'id' ]);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/event/event.resolver.ts